import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hideStars'
})
export class HideStarsPipe implements PipeTransform {

  transform(str:string, prcnt:number = 60): string {
    let idx:number = null as any;
    let res:string = "*********";
    if((idx = str.indexOf('@')) !== -1) {
      const idx_to_cut = Math.floor(idx*prcnt/100);
      res += str.substring(idx_to_cut);
    }
    else {
      res += str.substring(Math.floor(str.length * prcnt));
    }

    return res;
  }

}
